export class Equipe {}
